/**
 * 键盘控制 :: 把 store 中的 KeyBindings 转为 drei <KeyboardControls> 期望的 map。
 * Action 命名固定：forward / backward / left / right / jump / sprint / interact。
 * 对应 ecctrl 内部读取的 key 名。
 */
import type { KeyBindings } from '@/core/types'

export interface KeyMapEntry {
  name: string
  keys: string[]
}

/** ecctrl 期望的 action 名（不要重命名）。 */
export const ECCTRL_ACTIONS = [
  'forward',
  'backward',
  'leftward',
  'rightward',
  'jump',
  'run',
  'action1',
  'action2',
  'action3',
  'action4',
] as const

/**
 * 用户绑定 → drei keyboard controls map。
 * leftward/rightward/run 是 ecctrl 的命名；本项目 store 里用 left/right/sprint。
 */
export function bindingsToKeymap(bindings: KeyBindings): KeyMapEntry[] {
  return [
    { name: 'forward', keys: bindings.forward },
    { name: 'backward', keys: bindings.backward },
    { name: 'leftward', keys: bindings.left },
    { name: 'rightward', keys: bindings.right },
    { name: 'jump', keys: bindings.jump },
    { name: 'run', keys: bindings.sprint },
    // 互动 / 备用键。Phase 5 起用于上下船 / 拾取。
    { name: 'action1', keys: bindings.interact },
    { name: 'action2', keys: [] },
    { name: 'action3', keys: [] },
    { name: 'action4', keys: [] },
  ]
}
